<template>
  <v-card
    elevation="0"
    outlined
    rounded="xl"
    min-width="100%"
  >
    <v-card-title class="d-flex justify-center">
      <div
        class="text-caption text-uppercase text--secondary"
      >
        Текущее заявление
      </div>
    </v-card-title>
    <v-card-text
      v-if="Object.keys(show_statement_hostel).length === 0"
      class="d-flex align-center justify-center"
      style="height: calc(100% - 50px)"
    >
      <div v-if="!status_circular">
        <div class="text-center">
          <p>
            <v-icon color="teal" size="40">
              fa fa-address-card
            </v-icon>
          </p>
          <p>
            <v-btn
              @click="setStatement()"
              color="teal"
              dark
              x-large
            >
              Подать заявление
            </v-btn>
          </p>
        </div>
      </div>
      <div v-else class="text-center">
        <v-progress-circular
          indeterminate
          color="teal"
          width="4"
          size="70"
        ></v-progress-circular>
        <div>
          <v-chip
            class="ma-2"
            color="teal"
            text-color="white"
          >
            Формирование заявления
          </v-chip>
        </div>
      </div>
    </v-card-text>
    <v-card-text
      v-else
      class="pa-0"
      style="min-height: 100%"
    >
      <CurrStatement :dialog_sub_stm_visible="dialog_sub_stm_visible" @updateVisibleDialog="updateVisibleDialog"/>
    </v-card-text>
<!--    <div-->
<!--      class="text-center d-flex align-center justify-center"-->
<!--      style="min-height: 100%"-->
<!--      v-if="Object.keys(show_statement_hostel).length === 0"-->
<!--    >-->
<!--      <v-alert-->
<!--        v-if="check_period"-->
<!--        min-height="100%"-->
<!--        class="text-left d-flex justify-center align-center text-center"-->
<!--        border="left"-->
<!--        color="teal"-->
<!--        text-->
<!--        type="info"-->
<!--      >-->
<!--        {{ 'Срок подачи заявлений окончен. Подать заявление невовозможно!' }}-->
<!--      </v-alert>-->
<!--    </div>-->
    <DialogSubmitStatement :dialog_sub_stm_visible="dialog_sub_stm_visible" @updateVisibleDialog="updateVisibleDialog"/>
  </v-card>
</template>

<script>
    import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
    import StatementHostelPDF from '../../../../../makepdfs/statement_hostel/statement_hostel_pdf';
    import CurrPlaceHostel from "./CurrPlaceHostel.vue";
    import CurrStatement from "./CardCurrStatement.vue"
    import DialogSubmitStatement from "../../Dialogs/DialogSubmitStatement.vue"

    export default {
        name: 'CardHostelPlace',
        data: () => ({
            dialog_sub_stm_visible: false
        }),
        components: {
            CurrPlaceHostel,
            CurrStatement,
            DialogSubmitStatement,
        },
        mounted() {},
        computed: {
            ...mapState({
                user: state => state.mainHostel.user,
                show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
                status_circular: state => state.interactionStatement.status_circular,
            }),
            ...mapGetters({}),
            // check_period() {
            //     const deadline = new Date(new Date().getFullYear(), 6, 7)
            //     const current_date = new Date();
            //     if (current_date > deadline) {
            //         return false // доступ к системе
            //     } else return false
            // },
        },
        watch: {},
        methods: {
            ...mapMutations({
            }),
            ...mapActions({
            }),
            setStatement() {
                this.dialog_sub_stm_visible = !this.dialog_sub_stm_visible
            },
            updateVisibleDialog(prop){
                this.dialog_sub_stm_visible = prop.dialog_sub_stm_visible
            }
        },
    }
</script>

<style scoped>

</style>